import { PDPSOrdersClient, PUSHConnectOptions } from "gbet-api-client";
import { SubscribedBalance, SubscribedOrder } from "gbet-api-client/dist/PUSHClient/PDPS/PDPSTypes";
import GECStore from "./GECStore.ts";
export interface BalanceDelegate {
    // eslint-disable-next-line no-unused-vars
    (balance: SubscribedBalance): void;
}
export interface OrdersDelegate {
    // eslint-disable-next-line no-unused-vars
    (order: SubscribedOrder): void;
}

export default class PDPSStore {

    static balanceDelegates: {
        [key: number]: BalanceDelegate;
    } = {};

    static ordersDelegates: {
        [key: number]: OrdersDelegate;
    } = {};

    static initialized = false;

    static balanceDelegateCount = 0;

    static ordersDelegateCount = 0;

    static client: PDPSOrdersClient;

    static init = (options: PUSHConnectOptions) => {

        options.onStatusChange = function (status) {
            console.log("PDPSStatus", status);

            switch (status) {
                case "closed":
                    console.log("retry connection");

                    break;
            }
        };

        PDPSStore.client = new PDPSOrdersClient(options);
        PDPSStore.initialized = true;

    }

    static getClient = () => {
        return PDPSStore.client;
    }


    static get balance() {
        return PDPSStore.client.getBalance() || { availableBalance: 0, withdrawableBalance: 0 };
    }

    static async getBalance() {
        let connected = false;
        await PDPSStore.client.checkConnection(2).then(() => {
            connected = true;
        }).catch(() => {
            connected = false;
        });

        if (!connected) {
            await PDPSStore.startSubscriptions();
        }

        return PDPSStore.client.getBalance() || { availableBalance: 0, withdrawableBalance: 0 };
    }

    static async listOrders() {
        const orders = await PDPSStore.client.listOrdersByTimeChanged({});
        return orders;
    }

    static async startSubscriptions() {
        if (!PDPSStore.initialized) {
            return;
        }

        await PDPSStore.client.connect();
        await PDPSStore.client.logonPunter({
            sessionToken: GECStore.getController().getSessionToken(),
            integrationPartnerId: 0,
            currency: "EUR"
        });
        await PDPSStore.client.subscribeBalance({
            onBalanceChange: function (balance: SubscribedBalance) {
                //console.log(balance);

                for (const delegateId in PDPSStore.balanceDelegates) {
                    if (PDPSStore.balanceDelegates[delegateId]) {
                        PDPSStore.balanceDelegates[delegateId](balance);
                    }
                }

            }
        });

        //await PDPSStore.client.subscribeOrders({
        //    onOrderChange: function (order: SubscribedOrder) {
        //        for (const delegateId in PDPSStore.ordersDelegates) {
        //            if (PDPSStore.ordersDelegates[delegateId]) {
        //                PDPSStore.ordersDelegates[delegateId](order);
        //            }
        //        }
        //    }, onNewOrder: function (order: SubscribedOrder) {
        //        for (const delegateId in PDPSStore.ordersDelegates) {
        //            if (PDPSStore.ordersDelegates[delegateId]) {
        //                PDPSStore.ordersDelegates[delegateId](order);
        //            }
        //        }
        //    }

        //});

    }

    static async endSubscriptions() {
        if (!PDPSStore.initialized) {
            return;
        }
        await PDPSStore.client.logoffPunter();
    }

    static addBalanceDelegate = (delegate: BalanceDelegate) => {
        PDPSStore.balanceDelegateCount++;
        PDPSStore.balanceDelegates[PDPSStore.balanceDelegateCount] = delegate;

        return PDPSStore.balanceDelegateCount;
    }

    static removeBalanceDelegate = (delegateId: number) => {
        console.log(delegateId);
        delete PDPSStore.balanceDelegates[delegateId];
    }

    static addOrdersDelegate = (delegate: OrdersDelegate) => {
        PDPSStore.ordersDelegateCount++;
        PDPSStore.ordersDelegates[PDPSStore.ordersDelegateCount] = delegate;

        return PDPSStore.balanceDelegateCount;
    }

    static removeOrdersDelegate = (delegateId: number) => {
        delete PDPSStore.ordersDelegates[delegateId];
    }

}